import React, { useCallback, useEffect } from "react";
import { Snackbar } from "../ui";
import { NotificationManager, NotificationContainer } from "react-notifications";
import ConfirmDialog from "./ConfirmDialog";
import Loader from "./loader/Loader";


const SnpBaseLayout = ({
  children,
  loader = false,
  dialogConfig,
  snackbarConfig,
  notificationConfig,
}) => {
  const {
    show,
    outSideClickDismiss,
    handleSubmit,
    title,
    subTitle,
    negativeAction,
    positiveAction,
    negativeReq,
    positiveReq,
    cancelExtra,
    gui,
    iconReq,
    iconContent,
    handleClose,
  } = dialogConfig || {};

  const { open, message, onClose, color, vertical, horizontal } = snackbarConfig || {};

  const { body, title: notiTitle, type, func, timeout } = notificationConfig || {};

  const handleSnackClose = useCallback(
    (event, reason) => {
      if (reason === "clickaway") return;
      onClose?.(event);
    },
    [onClose]
  );

  const onDialogClose = useCallback(
    (event) => {
      if (outSideClickDismiss) {
        handleClose?.(event);
      };
    },
    [outSideClickDismiss, handleClose]
  );

  useEffect(() => {
    if (notiTitle) {
      const contentUi = (
        <p style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}>{body}</p>
      );
      if (type === 1) {
        NotificationManager.info(notiTitle, contentUi, timeout, func);
      } else if (type === 2) {
        NotificationManager.warning(notiTitle, contentUi, timeout, func);
      } else {
        NotificationManager.error(notiTitle, contentUi, timeout, func);
      }
    }
  }, [notiTitle, body, type, timeout, func]);

  return (
    <div>
      <NotificationContainer />
      {loader && <Loader />}
      <div>{children}</div>

      {show && (
        <ConfirmDialog
          isOpen={show}
          title={title}
          subTitle={subTitle}
          negativeReq={negativeReq}
          negativeAction={negativeAction}
          positiveReq={positiveReq}
          positiveAction={positiveAction}
          onClose={onDialogClose}
          iconReq={iconReq}
          iconContent={iconContent}
          onSubmit={handleSubmit}
          cancelExtra={cancelExtra}
          onCancel={handleClose}
          gui={gui}
        />
      )}

      <Snackbar
        open={open}
        autoHideDuration={3000}
        message={message}
        onClose={handleSnackClose}
        anchorOrigin={{
          vertical: vertical || "bottom",
          horizontal: horizontal || "left",
        }}
        sx={{
          "& .UiSnackbarContent-root": {
            backgroundColor: color || "black",
            color: "#ffffff",
            maxWidth: "80vw",
            whiteSpace: "pre-wrap",
          },
        }}
      />
    </div>
  );
};

export default SnpBaseLayout;
